import { Component, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ColumnBase } from "@progress/kendo-angular-grid";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { EntityListAction, Permission } from "projects/sepidz-web-framework/src/lib/models";
import { GridColumnInfoDetail } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { GridFilter, HttpCommonService } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { DetailLedgerKind } from "../models/detailledgerkind.model";
import { DetailLedgerKindImportExcelFormComponent } from "./detail-ledger-kind-import-excel/detail-ledger-kind-import-excel-form.component";
import { DetailLedgerKindFormComponent } from "./detailledgerkind-form.component";
@Component({
  selector: "detailledgerkind-list",
  templateUrl: "detailledgerkind-list.component.html",
  styleUrls: ["detailledgerkind-list.component.scss"],
  providers: [HttpCommonService],
})
export class DetailLedgerKindListComponent extends BaseListComponent {
  @ViewChild("grid") grid: KGridComponent;
  loadingIndicator: boolean;
  inputEditorform: any;
  editingName: { name: string };
  private sub: any;
  constructor(private route: ActivatedRoute) {
    super();
    this.inputEditorform = DetailLedgerKindFormComponent;
    this.onActionClick = this.onActionClick.bind(this);
  }
  ngOnInit() {
    this.apiName = "DetailLedgerKind";
    this.areaName = "Accounting";
    this.label = this.translate("ClientApp.BackOffice.ACC.DetaiLedgerKind.DetaiLedgerKind");
    this.route.params.pipe(takeUntil(this.ngUnsubscribe)).subscribe((params) => {
      if (params.apiname) this.apiName = params.apiname;
    });
    this.setactions();
  }
  setactions() {
    this.actions = [
      {
        name: "ImportFromExcel",
        disabled: false,
        displayName: "ورودی اکسل",
        iconName: "icon-file-excel-o",
        apiName: "GroupLedger/ImportExcel",
        areaName: "Accounting",
        Form_Component: DetailLedgerKindImportExcelFormComponent,
        permission: Permission.samePermission,
      },
    ];
  }
  onActionClick(
    action: EntityListAction,
    onRowSelected: DetailLedgerKind,
    onRowsSelected: DetailLedgerKind[],
    isAllSelected: boolean,
    gridFilter: GridFilter[]
  ) {
    if (action.name === "ImportFromExcel") {
      var gridInfo = this.getGridInfo(this.grid.grid.columns.toArray());
      this.dialogService
        .open(
          action.Form_Component,
          {
            gridInfo: gridInfo,
            label: action.displayName,
          },
          {
            autoFocus: true,
            closeOnClickOutside: false,
          }
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((model: GridFilter[]) => {});
    }
  }

  getParamsForExportExcelWithPostMethod(): Promise<any> {
    return new Promise((resolve, reject) => {
      resolve(this.getGridInfo(this.grid.grid.columns.toArray()));
    });
  }

  getGridInfo(columns: ColumnBase[]): GridColumnInfoDetail[] {
    return columns
      .filter((x) => !x.hidden)
      .map((x) => {
        const info = new GridColumnInfoDetail();
        info.name = x["field"];
        info.hidden = x.hidden;
        info.orderindex = x.orderIndex;
        info.title = x.title;
        return info;
      });
  }
}
